import { VotedUsersProps } from './types.js';
import cls from 'classnames';
import React, { PureComponent } from 'react';
import ReactModal from 'react-modal';
import { withRicosContext, withZIndexContext } from 'ricos-context';
import { withRCEHelpers } from '../rce-helpers-context/index.js';
import { s as styles, V as VotedUsersModal } from '../../VotedUsersModal-b3691022.js';
import VoterAvatar from './VoterAvatar.js';
import 'prop-types';
import 'react-infinite-scroller';
import '../../style-inject.es-746bb8ed.js';
import '../../assets/icons/RemoveIcon.js';
import '../../assets/icons/LoaderIcon.js';
import 'wix-rich-content-ui-components';
import './FallbackAvatar.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class VotedUsersComponent extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      isOpen: false
    });
    __publicField(this, "closeModal", () => this.setState({ isOpen: false }));
    __publicField(this, "openModal", (e) => {
      const { showVoters, rce } = this.props;
      e.preventDefault();
      if (e.keyCode || !showVoters || rce.preventInteraction) {
        return;
      }
      this.setState({ isOpen: this.props.rce.isViewMode });
    });
  }
  getSiteMember(id) {
    var _a, _b;
    const siteMembers = ((_b = (_a = this.props.rce).getSiteMembers) == null ? void 0 : _b.call(_a)) || [];
    return siteMembers.find((siteMember) => siteMember.siteMemberId === id);
  }
  getSiteMembers() {
    var _a, _b;
    const { rce, option, showVoters } = this.props;
    const siteMembers = ((_a = rce.getSiteMembers) == null ? void 0 : _a.call(rce)) || [];
    if (!showVoters || !siteMembers) {
      return [];
    }
    return ((_b = option.latestVoters) == null ? void 0 : _b.map(this.getSiteMember.bind(this))) || [];
  }
  renderMember(member) {
    if (!member) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("li", { key: member.siteMemberId, className: styles.avatar }, /* @__PURE__ */ React.createElement(
      VoterAvatar,
      {
        className: styles.avatar,
        memberInfo: member,
        src: member.imageUrl,
        size: {
          width: 20,
          height: 20
        }
      }
    ));
  }
  render() {
    var _a, _b;
    const { option, t, showResults, showVotes, showVoters, fetchVoters, rce, isMobile } = this.props;
    const { isOpen, $container } = this.state;
    if (!showResults || !showVotes || !option.count) {
      return null;
    }
    const zIndex = this.props.zIndexService.getZIndex(isMobile ? "DRAWER" : "DIALOG");
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.container, {
          [styles.cta]: showVoters && ((_a = option.latestVoters) == null ? void 0 : _a.length),
          [styles.webview]: rce.isWebView
        }),
        ref: ($container2) => this.setState({ $container: $container2 }),
        onClick: this.openModal,
        onKeyPress: this.openModal,
        role: "button",
        "aria-haspopup": "dialog",
        tabIndex: 0
      },
      /* @__PURE__ */ React.createElement("ul", { className: styles.avatar_list }, this.getSiteMembers().map(this.renderMember)),
      /* @__PURE__ */ React.createElement("span", { "data-hook": "pollsVotedUserItem" }, t("Poll_Viewer_VoteCount", { number: option.count || 0 }))
    ), $container && ((_b = option.latestVoters) == null ? void 0 : _b.length) ? /* @__PURE__ */ React.createElement(
      ReactModal,
      {
        isOpen,
        onRequestClose: this.closeModal,
        parentSelector: () => document.body,
        className: cls(styles.modal),
        overlayClassName: cls(styles.overlay),
        style: { overlay: { zIndex } }
      },
      /* @__PURE__ */ React.createElement(
        VotedUsersModal,
        {
          option,
          fetchVoters,
          getSiteMember: this.getSiteMember.bind(this),
          onRequestClose: this.closeModal
        }
      )
    ) : null);
  }
}
__publicField(VotedUsersComponent, "propTypes", __spreadValues({}, VotedUsersProps));
const VotedUsers = withRicosContext(withZIndexContext(withRCEHelpers(VotedUsersComponent)));

export { VotedUsers };
//# sourceMappingURL=VotedUsers.js.map
